import { FormControlLabel, Radio, Typography } from '@mui/material';

type WizardRadioButtonProps = {
  value: string;
  text: string;
  disabled?: boolean;
};

const WizardRadioButton = ({ value, text, disabled = false }: WizardRadioButtonProps) => (
  <FormControlLabel
    value={value}
    disabled={disabled}
    control={<Radio size="small" />}
    label={<Typography variant="subtitle1">{text}</Typography>}
  />
);

export default WizardRadioButton;
